// Termos de Uso — Alpha Translations
// Versão: 2026-04-20
// Em caso de divergência entre versões, prevalece a versão em inglês (cláusula 14).

export const TERMS_VERSION = "2026-04-20";

// Helper de estrutura:
// {
//   title, lastUpdated, intro,
//   sections: [
//     { title, paragraphs?: string[], list?: string[], subsections?: [{ title, paragraphs?, list? }] }
//   ]
// }

const pt = {
  title: "TERMOS DE USO – ALPHA TRANSLATIONS",
  lastUpdated: "Última atualização: 20 de abril de 2026",
  intro:
    "Ao acessar o site ou contratar os serviços da Alpha Translations, o cliente declara que leu, entendeu e concorda integralmente com os presentes Termos de Uso.",
  sections: [
    {
      title: "1. ACEITAÇÃO DOS TERMOS",
      paragraphs: [
        "Ao solicitar um orçamento, efetuar pagamento ou prosseguir com a contratação de qualquer serviço, o cliente concorda automaticamente com estes Termos de Uso, que possuem caráter vinculante.",
        "A Alpha Translations não garante que todo o conteúdo, serviços ou materiais estejam sempre completos, atualizados ou livres de erros, sendo responsabilidade do cliente esclarecer quaisquer dúvidas antes da contratação.",
      ],
    },
    {
      title: "2. SERVIÇOS PRESTADOS",
      paragraphs: ["A Alpha Translations oferece exclusivamente:"],
      list: ["Tradução de documentos", "Serviços de interpretação (presencial e remota)"],
      paragraphs2: [
        "Os serviços são prestados considerando sua natureza linguística e interpretativa, podendo haver variações terminológicas, de estilo ou interpretação.",
      ],
    },
    {
      title: "3. EXECUÇÃO E PAGAMENTO",
      list: [
        "Os serviços terão início após a confirmação do pagamento, salvo acordo em contrário",
        "Os prazos informados são estimativas e podem variar conforme a complexidade",
      ],
    },
    {
      title: "4. POLÍTICA DE REEMBOLSO",
      paragraphs: [
        "Todos os pagamentos realizados à Alpha Translations são finais e não reembolsáveis, uma vez que os serviços envolvem alocação imediata de recursos e tempo especializado.",
        "Ao efetuar o pagamento, o cliente declara que:",
      ],
      list: ["revisou e aprovou o orçamento", "compreende o escopo do serviço", "concorda com estes Termos de Uso"],
      subsections: [
        {
          title: "4.1 Correções e Ajustes",
          paragraphs: ["Caso o cliente identifique inconsistências:"],
          list: [
            "deverá comunicar em até 24 (vinte e quatro) horas após a entrega",
            "dentro desse prazo, a Alpha Translations poderá revisar o conteúdo sem custo adicional",
          ],
          paragraphs2: ["Após esse prazo:"],
          list2: [
            "o serviço será considerado aceito",
            "ajustes poderão ser cobrados como novo serviço",
          ],
        },
        {
          title: "4.2 Serviços de Interpretação",
          paragraphs: ["Para serviços de interpretação:"],
          list: ["não há reembolso após a reserva", "aplica-se mínimo de 3 (três) horas"],
          paragraphs2: ["Mesmo que o serviço não ocorra por:"],
          list2: [
            "ausência de participantes",
            "erro de idioma",
            "falha de terceiros",
            "cancelamento por órgãos ou instituições (ex: USCIS)",
          ],
          paragraphs3: ["o serviço será considerado prestado e não haverá reembolso."],
        },
        {
          title: "4.3 Cancelamentos",
          list: [
            "Cancelamentos não geram reembolso",
            "Poderá ser concedido crédito, a critério exclusivo da Alpha Translations",
          ],
        },
        {
          title: "4.4 Disputas e Chargebacks",
          paragraphs: ["Ao realizar o pagamento, o cliente concorda em:"],
          list: [
            "não abrir disputas ou chargebacks indevidos",
            "buscar resolução diretamente com a Alpha Translations antes de qualquer contestação",
          ],
          paragraphs2: ["Chargebacks indevidos poderão resultar em:"],
          list2: ["suspensão de serviços", "medidas administrativas e legais cabíveis"],
        },
      ],
    },
    {
      title: "5. PRAZO DE REVISÃO E ACEITAÇÃO",
      paragraphs: [
        "O cliente deverá revisar todo material entregue no prazo máximo de 24 (vinte e quatro) horas a partir da entrega.",
        "Após esse prazo:",
      ],
      list: [
        "o material será considerado automaticamente aceito",
        "a aceitação será considerada irrevogável e irretratável",
        "a Alpha Translations não se responsabiliza por erros, omissões ou interpretações não reportadas",
      ],
      paragraphs2: [
        "A empresa não se responsabiliza por quaisquer consequências decorrentes do uso do material sem revisão dentro do prazo estipulado.",
      ],
    },
    {
      title: "6. SERVIÇOS DE INTERPRETAÇÃO",
      subsections: [
        {
          title: "6.1 Natureza do Serviço",
          paragraphs: [
            "Os serviços de interpretação são realizados em tempo real e podem apresentar variações naturais de linguagem.",
            "Não é garantida precisão absoluta.",
          ],
        },
        {
          title: "6.2 Cobrança",
          list: [
            "Os serviços são cobrados por hora",
            "Aplica-se um mínimo obrigatório de 3 (três) horas por contratação",
          ],
        },
        {
          title: "6.3 Comparecimento, Atrasos e No-Show",
          list: [
            "O tempo reservado será cobrado integralmente",
            "Atrasos ou ausência do cliente ou de terceiros não isentam o pagamento",
          ],
          paragraphs2: ["Caso o serviço não seja realizado por motivos alheios à Alpha Translations, incluindo:"],
          list2: [
            "ausência de participantes",
            "indisponibilidade de terceiros ou instituições",
            "falta de intérprete adicional necessário",
            "problemas administrativos ou operacionais",
          ],
          paragraphs3: ["o serviço será considerado devidamente prestado e não haverá reembolso."],
        },
        {
          title: "6.4 Responsabilidade do Cliente",
          paragraphs: ["O cliente é exclusivamente responsável por:"],
          list: [
            "fornecer informações corretas sobre o idioma necessário",
            "garantir que todas as partes envolvidas estejam aptas à comunicação",
            "providenciar intérpretes adicionais quando necessário",
          ],
          paragraphs2: ["A Alpha Translations não se responsabiliza por:"],
          list2: [
            "erros decorrentes da escolha incorreta de idioma",
            "falhas de comunicação entre terceiros",
            "remarcações, cancelamentos ou atrasos causados por terceiros",
          ],
          paragraphs3: [
            "O serviço será considerado devidamente prestado mesmo que o objetivo final não seja alcançado por fatores fora do controle da empresa.",
          ],
        },
      ],
    },
    {
      title: "7. LIMITAÇÃO DE ESCOPO",
      paragraphs: ["A Alpha Translations presta exclusivamente serviços linguísticos.", "Não se responsabiliza por:"],
      list: [
        "aconselhamento jurídico, migratório, médico ou técnico",
        "resultados de processos administrativos ou judiciais",
        "decisões tomadas com base no conteúdo traduzido ou interpretado",
      ],
    },
    {
      title: "8. ARMAZENAMENTO E BACKUP DE ARQUIVOS",
      list: [
        "Os documentos serão disponibilizados ao cliente por meio do portal da empresa",
        "Os arquivos poderão ser acessados e baixados por até 60 (sessenta) dias após a entrega",
      ],
      paragraphs2: ["Após esse período:"],
      list2: [
        "os arquivos poderão ser excluídos permanentemente",
        "a Alpha Translations não terá obrigação de manter backups ou cópias",
      ],
      paragraphs3: ["A responsabilidade pelo armazenamento é exclusivamente do cliente."],
    },
    {
      title: "9. PROTEÇÃO DE DADOS",
      list: [
        "Os dados e documentos do cliente serão utilizados exclusivamente para a prestação dos serviços",
        "A Alpha Translations adota medidas razoáveis de segurança",
        "Os arquivos poderão ser excluídos após 60 dias, salvo solicitação formal em contrário",
      ],
    },
    {
      title: "10. LIMITAÇÃO DE RESPONSABILIDADE",
      paragraphs: [
        "Os serviços prestados envolvem interpretação linguística e podem apresentar variações de significado, contexto e terminologia.",
        "O cliente reconhece que:",
      ],
      list: [
        "traduções não são reproduções exatas",
        "podem ocorrer variações linguísticas",
        "deve revisar o material antes do uso",
      ],
      paragraphs2: ["A Alpha Translations não será responsável por:"],
      list2: [
        "erros não reportados dentro do prazo",
        "decisões baseadas no conteúdo",
        "danos diretos ou indiretos",
      ],
      paragraphs3: [
        "O uso do material é de responsabilidade exclusiva do cliente.",
        "A responsabilidade total da Alpha Translations estará limitada ao valor pago pelo serviço.",
      ],
    },
    {
      title: "11. FORÇA MAIOR",
      paragraphs: ["A Alpha Translations não será responsável por eventos fora de seu controle, incluindo:"],
      list: ["decisões governamentais", "falhas técnicas", "indisponibilidade de internet ou energia"],
    },
    {
      title: "12. SEGURANÇA",
      paragraphs: ["A Alpha Translations não se responsabiliza por comunicações fraudulentas feitas por terceiros."],
    },
    {
      title: "13. LEGISLAÇÃO APLICÁVEL",
      paragraphs: ["Estes Termos são regidos pelas leis do Estado da Flórida, EUA."],
    },
    {
      title: "14. IDIOMA",
      paragraphs: ["Em caso de divergência entre versões traduzidas, prevalecerá a versão em inglês."],
    },
    {
      title: "15. CONTATO",
      list: [
        "🌐 https://alpha-translations.com/",
        "📧 support@alpha-translations.com",
        "📞 +1 (407) 385-9794",
      ],
    },
    {
      title: "16. COMUNICAÇÕES, SMS E CONTATO",
      paragraphs: ["Ao fornecer seus dados, o cliente concorda em receber comunicações relacionadas a:"],
      list: ["serviços contratados", "suporte", "atualizações", "ofertas promocionais e cupons de desconto"],
      subsections: [
        {
          title: "16.1 SMS e WhatsApp",
          paragraphs: ["O cliente autoriza o recebimento de mensagens."],
          list: ["frequência variável", "podem haver custos da operadora"],
          paragraphs2: ["Pode cancelar a qualquer momento:"],
          list2: ['respondendo "STOP"', "solicitando pelos canais oficiais"],
        },
        {
          title: "16.2 E-mail",
          paragraphs: ["O cliente poderá receber comunicações e promoções.", "Pode cancelar:"],
          list: ["pelo link de descadastro", "ou contato direto"],
        },
        {
          title: "16.3 Segurança",
          paragraphs: ["A empresa utiliza apenas e-mails com domínio:"],
          list: ["@alpha-translations.com"],
          paragraphs2: ["Não se responsabiliza por fraudes de terceiros."],
        },
      ],
    },
  ],
};

const en = {
  title: "TERMS OF USE – ALPHA TRANSLATIONS",
  lastUpdated: "Last updated: April 20, 2026",
  intro:
    "By accessing this website or contracting the services of Alpha Translations, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use.",
  sections: [
    {
      title: "1. ACCEPTANCE OF TERMS",
      paragraphs: [
        "By requesting a quote, making a payment, or proceeding with any service, the client automatically agrees to these Terms of Use, which are legally binding.",
        "Alpha Translations does not guarantee that all content, services, or materials will always be complete, current, or error-free. It is the client's responsibility to clarify any questions prior to contracting services.",
      ],
    },
    {
      title: "2. SERVICES PROVIDED",
      paragraphs: ["Alpha Translations exclusively provides:"],
      list: ["Document translation services", "Interpretation services (in-person and remote)"],
      paragraphs2: [
        "Services are provided considering their linguistic and interpretative nature and may involve variations in terminology, style, or interpretation.",
      ],
    },
    {
      title: "3. EXECUTION AND PAYMENT",
      list: [
        "Services will begin upon confirmation of payment, unless otherwise agreed",
        "Delivery timelines are estimates and may vary depending on complexity",
      ],
    },
    {
      title: "4. REFUND POLICY",
      paragraphs: [
        "All payments made to Alpha Translations are final and non-refundable, as services involve the immediate allocation of time and specialized resources.",
        "By making a payment, the client confirms that:",
      ],
      list: [
        "they have reviewed and approved the quote",
        "they understand the scope of the service",
        "they agree to these Terms of Use",
      ],
      subsections: [
        {
          title: "4.1 Corrections and Adjustments",
          paragraphs: ["If the client identifies any inconsistencies:"],
          list: [
            "they must notify Alpha Translations within 24 (twenty-four) hours after delivery",
            "within this period, Alpha Translations may review and correct the content at no additional cost",
          ],
          paragraphs2: ["After this period:"],
          list2: [
            "the service will be deemed accepted",
            "any additional changes may be treated as a new service",
          ],
        },
        {
          title: "4.2 Interpretation Services",
          paragraphs: ["For interpretation services:"],
          list: [
            "no refunds are provided once the time has been reserved",
            "a minimum charge of 3 (three) hours applies",
          ],
          paragraphs2: ["Even if the service does not take place due to:"],
          list2: [
            "absence of participants",
            "incorrect language selection",
            "third-party issues",
            "cancellations or rescheduling by institutions (e.g., USCIS)",
          ],
          paragraphs3: ["the service shall be considered rendered and no refund will be issued."],
        },
        {
          title: "4.3 Cancellations",
          list: [
            "Cancellations do not qualify for refunds",
            "At Alpha Translations' sole discretion, a credit may be issued",
          ],
        },
        {
          title: "4.4 Disputes and Chargebacks",
          paragraphs: ["By making a payment, the client agrees to:"],
          list: [
            "not initiate unjustified disputes or chargebacks",
            "contact Alpha Translations first to resolve any issue",
          ],
          paragraphs2: ["Improper chargebacks may result in:"],
          list2: ["suspension of services", "administrative or legal action"],
        },
      ],
    },
    {
      title: "5. REVIEW PERIOD AND ACCEPTANCE",
      paragraphs: [
        "The client must review all delivered materials within 24 (twenty-four) hours.",
        "After this period:",
      ],
      list: [
        "the material will be deemed automatically accepted",
        "acceptance is final and irrevocable",
        "Alpha Translations shall not be responsible for unreported errors, omissions, or interpretations",
      ],
      paragraphs2: [
        "Alpha Translations is not liable for any consequences arising from the use of materials not reviewed within the specified timeframe.",
      ],
    },
    {
      title: "6. INTERPRETATION SERVICES",
      subsections: [
        {
          title: "6.1 Nature of the Service",
          paragraphs: [
            "Interpretation services are performed in real time and may involve natural linguistic variations.",
            "Absolute accuracy is not guaranteed.",
          ],
        },
        {
          title: "6.2 Billing",
          list: ["Services are billed hourly", "A minimum of 3 (three) hours per booking applies"],
        },
        {
          title: "6.3 Attendance, Delays, and No-Show",
          list: [
            "Reserved time will be billed in full",
            "Delays or absence of the client or third parties do not exempt payment",
          ],
          paragraphs2: [
            "If the service is not rendered due to factors beyond Alpha Translations' control, including:",
          ],
          list2: [
            "absence of participants",
            "unavailability of third parties or institutions",
            "lack of an additional required interpreter",
            "administrative or operational issues",
          ],
          paragraphs3: ["the service shall be deemed rendered and no refund will be issued."],
        },
        {
          title: "6.4 Client Responsibility",
          paragraphs: ["The client is solely responsible for:"],
          list: [
            "providing correct language requirements",
            "ensuring all parties are prepared",
            "arranging additional interpreters if needed",
          ],
          paragraphs2: ["Alpha Translations is not responsible for:"],
          list2: [
            "incorrect language selection",
            "third-party failures",
            "external cancellations or delays",
          ],
          paragraphs3: [
            "The service is considered rendered even if the intended outcome is not achieved due to factors beyond the company's control.",
          ],
        },
      ],
    },
    {
      title: "7. LIMITATION OF SCOPE",
      paragraphs: [
        "Alpha Translations provides strictly linguistic services.",
        "We are not responsible for:",
      ],
      list: [
        "legal, immigration, medical, or technical advice",
        "outcomes of administrative or judicial processes",
        "decisions based on translated or interpreted content",
      ],
    },
    {
      title: "8. FILE STORAGE AND BACKUP",
      list: [
        "Documents are made available to the client through the company portal",
        "Files may be accessed and downloaded for up to 60 (sixty) days after delivery",
      ],
      paragraphs2: ["After this period:"],
      list2: [
        "files may be permanently deleted",
        "Alpha Translations has no obligation to maintain backups or copies",
      ],
      paragraphs3: ["Storage is the sole responsibility of the client."],
    },
    {
      title: "9. DATA PROTECTION",
      list: [
        "Client data and documents will be used exclusively for the provision of services",
        "Alpha Translations applies reasonable security measures",
        "Files may be deleted after 60 days unless otherwise formally requested",
      ],
    },
    {
      title: "10. LIMITATION OF LIABILITY",
      paragraphs: [
        "Services involve linguistic interpretation and may vary in meaning, context, or terminology.",
        "The client acknowledges:",
      ],
      list: [
        "translations are not exact reproductions",
        "linguistic variations may occur",
        "materials must be reviewed before use",
      ],
      paragraphs2: ["Alpha Translations is not liable for:"],
      list2: [
        "unreported errors within the specified timeframe",
        "decisions based on content",
        "direct or indirect damages",
      ],
      paragraphs3: [
        "Use of the material is at the client's sole risk.",
        "Total liability is limited to the amount paid for the service.",
      ],
    },
    {
      title: "11. FORCE MAJEURE",
      paragraphs: ["Alpha Translations is not responsible for events beyond its control, including:"],
      list: ["government actions", "system failures", "internet or power unavailability"],
    },
    {
      title: "12. SECURITY",
      paragraphs: ["Alpha Translations is not responsible for fraudulent communications by third parties."],
    },
    {
      title: "13. GOVERNING LAW",
      paragraphs: ["These Terms are governed by the laws of the State of Florida, USA."],
    },
    {
      title: "14. LANGUAGE",
      paragraphs: ["In case of discrepancies between translated versions, the English version shall prevail."],
    },
    {
      title: "15. CONTACT",
      list: [
        "🌐 https://alpha-translations.com/",
        "📧 support@alpha-translations.com",
        "📞 +1 (407) 385-9794",
      ],
    },
    {
      title: "16. COMMUNICATIONS, SMS AND CONTACT",
      paragraphs: ["By providing contact details, the client agrees to receive communications related to:"],
      list: ["contracted services", "support", "updates", "promotional offers and discount coupons"],
      subsections: [
        {
          title: "16.1 SMS and WhatsApp",
          paragraphs: ["The client consents to receive messages."],
          list: ["message frequency may vary", "carrier charges may apply"],
          paragraphs2: ["Opt-out anytime:"],
          list2: ['reply "STOP"', "contact the company through official channels"],
        },
        {
          title: "16.2 Email",
          paragraphs: ["The client may receive communications and promotions.", "Opt-out:"],
          list: ["unsubscribe link", "direct contact"],
        },
        {
          title: "16.3 Security Notice",
          paragraphs: ["Official communications are sent only from:"],
          list: ["@alpha-translations.com"],
          paragraphs2: ["We are not responsible for impersonation or fraud."],
        },
      ],
    },
  ],
};

const es = {
  title: "TÉRMINOS DE USO – ALPHA TRANSLATIONS",
  lastUpdated: "Última actualización: 20 de abril de 2026",
  intro:
    "Al acceder a este sitio web o contratar los servicios de Alpha Translations, el cliente declara que ha leído, entendido y acepta estos Términos de Uso en su totalidad.",
  sections: [
    {
      title: "1. ACEPTACIÓN DE LOS TÉRMINOS",
      paragraphs: [
        "Al solicitar un presupuesto, realizar un pago o proceder con cualquier servicio, el cliente acepta automáticamente estos Términos de Uso, los cuales son legalmente vinculantes.",
        "Alpha Translations no garantiza que todo el contenido, servicios o materiales estén siempre completos, actualizados o libres de errores. Es responsabilidad del cliente aclarar cualquier duda antes de contratar los servicios.",
      ],
    },
    {
      title: "2. SERVICIOS PRESTADOS",
      paragraphs: ["Alpha Translations ofrece exclusivamente:"],
      list: ["Traducción de documentos", "Servicios de interpretación (presencial y remota)"],
      paragraphs2: [
        "Los servicios se prestan considerando su naturaleza lingüística e interpretativa, pudiendo existir variaciones terminológicas, de estilo o interpretación.",
      ],
    },
    {
      title: "3. EJECUCIÓN Y PAGO",
      list: [
        "Los servicios comenzarán tras la confirmación del pago, salvo acuerdo en contrario",
        "Los plazos de entrega son estimados y pueden variar según la complejidad",
      ],
    },
    {
      title: "4. POLÍTICA DE REEMBOLSO",
      paragraphs: [
        "Todos los pagos realizados a Alpha Translations son finales y no reembolsables, ya que implican la asignación inmediata de tiempo y recursos especializados.",
        "Al realizar el pago, el cliente confirma que:",
      ],
      list: [
        "ha revisado y aprobado el presupuesto",
        "comprende el alcance del servicio",
        "acepta estos Términos de Uso",
      ],
      subsections: [
        {
          title: "4.1 Correcciones y Ajustes",
          paragraphs: ["Si el cliente detecta inconsistencias:"],
          list: [
            "deberá notificar dentro de 24 (veinticuatro) horas tras la entrega",
            "dentro de este plazo, Alpha Translations podrá corregir el contenido sin costo adicional",
          ],
          paragraphs2: ["Después de este período:"],
          list2: [
            "el servicio se considerará aceptado",
            "cualquier modificación podrá tratarse como un nuevo servicio",
          ],
        },
        {
          title: "4.2 Servicios de Interpretación",
          paragraphs: ["Para los servicios de interpretación:"],
          list: [
            "no se ofrecen reembolsos una vez reservado el tiempo",
            "se aplica un mínimo de 3 (tres) horas",
          ],
          paragraphs2: ["Incluso si el servicio no se realiza debido a:"],
          list2: [
            "ausencia de participantes",
            "selección incorrecta del idioma",
            "fallos de terceros",
            "cancelaciones o reprogramaciones por instituciones (ej.: USCIS)",
          ],
          paragraphs3: ["el servicio se considerará prestado y no se realizará ningún reembolso."],
        },
        {
          title: "4.3 Cancelaciones",
          list: [
            "Las cancelaciones no generan reembolso",
            "A discreción exclusiva de Alpha Translations, podrá otorgarse crédito para uso futuro",
          ],
        },
        {
          title: "4.4 Disputas y Chargebacks",
          paragraphs: ["Al realizar el pago, el cliente acepta:"],
          list: [
            "no iniciar disputas o devoluciones de cargo (chargebacks) indebidas",
            "contactar previamente a Alpha Translations para resolver cualquier problema",
          ],
          paragraphs2: ["Los chargebacks indebidos pueden resultar en:"],
          list2: ["suspensión de servicios", "acciones administrativas o legales pertinentes"],
        },
      ],
    },
    {
      title: "5. PLAZO DE REVISIÓN Y ACEPTACIÓN",
      paragraphs: [
        "El cliente deberá revisar todo el material dentro de un plazo máximo de 24 (veinticuatro) horas a partir de la entrega.",
        "Después de este período:",
      ],
      list: [
        "el material se considerará automáticamente aceptado",
        "la aceptación será final, irrevocable e irretratable",
        "Alpha Translations no será responsable por errores, omisiones o interpretaciones no reportados",
      ],
      paragraphs2: [
        "Alpha Translations no se responsabiliza por consecuencias derivadas del uso del material no revisado dentro del plazo estipulado.",
      ],
    },
    {
      title: "6. SERVICIOS DE INTERPRETACIÓN",
      subsections: [
        {
          title: "6.1 Naturaleza del Servicio",
          paragraphs: [
            "Los servicios de interpretación se realizan en tiempo real y pueden presentar variaciones naturales del lenguaje.",
            "No se garantiza precisión absoluta.",
          ],
        },
        {
          title: "6.2 Facturación",
          list: [
            "Los servicios se cobran por hora",
            "Se aplica un mínimo de 3 (tres) horas por contratación",
          ],
        },
        {
          title: "6.3 Asistencia, Retrasos y Ausencias",
          list: [
            "El tiempo reservado será cobrado en su totalidad",
            "La ausencia o retraso del cliente o de terceros no exime del pago",
          ],
          paragraphs2: [
            "Si el servicio no se realiza por motivos ajenos a Alpha Translations, incluyendo:",
          ],
          list2: [
            "ausencia de participantes",
            "indisponibilidad de terceros o instituciones",
            "falta de un intérprete adicional necesario",
            "problemas administrativos u operativos",
          ],
          paragraphs3: [
            "el servicio se considerará debidamente prestado y no se realizará reembolso.",
          ],
        },
        {
          title: "6.4 Responsabilidad del Cliente",
          paragraphs: ["El cliente es exclusivamente responsable de:"],
          list: [
            "proporcionar información correcta sobre el idioma requerido",
            "garantizar que todas las partes involucradas estén preparadas para la comunicación",
            "contratar intérpretes adicionales cuando sea necesario",
          ],
          paragraphs2: ["Alpha Translations no se responsabiliza por:"],
          list2: [
            "errores derivados de la selección incorrecta del idioma",
            "fallos de comunicación entre terceros",
            "reprogramaciones, cancelaciones o retrasos causados por terceros",
          ],
          paragraphs3: [
            "El servicio se considera debidamente prestado aunque el objetivo final no se alcance por factores fuera del control de la empresa.",
          ],
        },
      ],
    },
    {
      title: "7. LIMITACIÓN DE ALCANCE",
      paragraphs: ["Alpha Translations presta únicamente servicios lingüísticos.", "No se responsabiliza por:"],
      list: [
        "asesoramiento legal, migratorio, médico o técnico",
        "resultados de procesos administrativos o judiciales",
        "decisiones basadas en el contenido traducido o interpretado",
      ],
    },
    {
      title: "8. ALMACENAMIENTO Y RESPALDO DE ARCHIVOS",
      list: [
        "Los documentos se pondrán a disposición del cliente a través del portal de la empresa",
        "Los archivos podrán accederse y descargarse durante hasta 60 (sesenta) días después de la entrega",
      ],
      paragraphs2: ["Después de este período:"],
      list2: [
        "los archivos podrán ser eliminados permanentemente",
        "Alpha Translations no tendrá obligación de mantener respaldos o copias",
      ],
      paragraphs3: ["El almacenamiento es responsabilidad exclusiva del cliente."],
    },
    {
      title: "9. PROTECCIÓN DE DATOS",
      list: [
        "Los datos y documentos del cliente se utilizarán exclusivamente para la prestación de los servicios",
        "Alpha Translations adopta medidas razonables de seguridad",
        "Los archivos podrán eliminarse después de 60 días, salvo solicitud formal en contrario",
      ],
    },
    {
      title: "10. LIMITACIÓN DE RESPONSABILIDAD",
      paragraphs: [
        "Los servicios prestados involucran interpretación lingüística y pueden presentar variaciones de significado, contexto y terminología.",
        "El cliente reconoce que:",
      ],
      list: [
        "las traducciones no son reproducciones exactas",
        "pueden ocurrir variaciones lingüísticas",
        "deben revisar el material antes de su uso",
      ],
      paragraphs2: ["Alpha Translations no será responsable por:"],
      list2: [
        "errores no reportados dentro del plazo",
        "decisiones basadas en el contenido",
        "daños directos o indirectos",
      ],
      paragraphs3: [
        "El uso del material es responsabilidad exclusiva del cliente.",
        "La responsabilidad total de Alpha Translations se limita al monto pagado por el servicio.",
      ],
    },
    {
      title: "11. FUERZA MAYOR",
      paragraphs: ["Alpha Translations no será responsable por eventos fuera de su control, incluyendo:"],
      list: ["acciones gubernamentales", "fallos técnicos", "indisponibilidad de internet o energía"],
    },
    {
      title: "12. SEGURIDAD",
      paragraphs: ["Alpha Translations no se responsabiliza por comunicaciones fraudulentas realizadas por terceros."],
    },
    {
      title: "13. LEGISLACIÓN APLICABLE",
      paragraphs: ["Estos Términos se rigen por las leyes del Estado de Florida, EE.UU."],
    },
    {
      title: "14. IDIOMA",
      paragraphs: ["En caso de discrepancia entre versiones traducidas, prevalecerá la versión en inglés."],
    },
    {
      title: "15. CONTACTO",
      list: [
        "🌐 https://alpha-translations.com/",
        "📧 support@alpha-translations.com",
        "📞 +1 (407) 385-9794",
      ],
    },
    {
      title: "16. COMUNICACIONES, SMS Y CONTACTO",
      paragraphs: ["Al proporcionar sus datos, el cliente acepta recibir comunicaciones relacionadas con:"],
      list: [
        "servicios contratados",
        "soporte",
        "actualizaciones",
        "ofertas promocionales y cupones de descuento",
      ],
      subsections: [
        {
          title: "16.1 SMS y WhatsApp",
          paragraphs: ["El cliente autoriza la recepción de mensajes."],
          list: ["frecuencia variable", "pueden aplicarse tarifas del operador"],
          paragraphs2: ["Puede cancelar en cualquier momento:"],
          list2: ['respondiendo "STOP"', "solicitando por los canales oficiales"],
        },
        {
          title: "16.2 Correo Electrónico",
          paragraphs: ["El cliente podrá recibir comunicaciones y promociones.", "Puede cancelar:"],
          list: ["mediante enlace de baja", "o contacto directo"],
        },
        {
          title: "16.3 Seguridad",
          paragraphs: ["La empresa utiliza únicamente correos con dominio:"],
          list: ["@alpha-translations.com"],
          paragraphs2: ["No se responsabiliza por fraudes de terceros."],
        },
      ],
    },
  ],
};

const TERMS_CONTENT = { pt, en, es };

export default TERMS_CONTENT;
